import React from "react";
import {Nav} from 'react-bootstrap';
import WhiteLogo from '../../../assets/images/white-logo.png';
import Paypal from '../../../assets/images/paypal.jpg';
import Secure from '../../../assets/images/secure.jpg';

export default function Footer(prop) {
    
    return(
        <> 
           <div className="main-container footer">
                <div className="container ">
                    <div className="row margin-bottom">
                        <div className="col-md-4">
                            <img width='50%' style={{marginBottom:'20px'}} src={WhiteLogo}/>
                            <p>
                                {prop.literals.para2}
                            </p>
                        </div> 
                        <div className="col-md-4">
                            <h6 className="text-white">
                                {prop.literals.quickLinks}
                            </h6>
                            <Nav defaultActiveKey="#" className="flex-column text-uppercase">                           
                                <Nav.Link href="/">
                                    {prop.literals.home}
                                </Nav.Link>
                                <Nav.Link href="/about-us">
                                    {prop.literals.about}
                                </Nav.Link>                           
                                <Nav.Link href="/services">
                                    {prop.literals.services}
                                </Nav.Link>
                                {/* <Nav.Link href="/parkeo/contact-us">
                                    {props.displayLang == 'en' ? props.prop.literals[1].en : props.prop.literals[1].fr}    
                                </Nav.Link>*/}
                            </Nav>
                        </div>
                        <div className="col-md-4">
                            {/* <h6 className="text-white">
                                {prop.literals.signNewsletter}
                            </h6>
                            <p>
                                {prop.literals.subscribeNews}
                            </p>

                            <div className="input-group mb-3">
                                <input type="text" className="form-control" aria-label="Recipient's username" aria-describedby="button-addon2"/>
                                <div className="input-group-append">
                                    <button className="btn btn-default" type="button" id="button-addon2">
                                        {prop.literals.submit}
                                    </button>
                                </div>
                            </div>                             */}
                            <h6 className="text-white">
                                {prop.literals.paySecure}
                            </h6>
                            <img width='90px' style={{margin:'5px 5px'}} src={Paypal}/>
                            <img width='90px' style={{margin:'5px'}} src={Secure}/>
                        </div>
                    </div>
                </div>
                <div className="row copyright">
                    <div className="col-md-12">
                        <p className="m-0">© {new Date().getFullYear()} Park45.ca, All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </>
    )
}